/* eslint-disable dot-notation,global-require,import/no-extraneous-dependencies */
import qs from 'querystring';
import Cookies from 'universal-cookie';
import { getLocaleCode } from 'utils/localeHalper';
import { getClientSignatureHeader } from './clientSignatureBuilder';

const cookies = new Cookies();

// Получение токена авторизации в зависимости от типа полатформы
async function getAutKey() {
  let authKey = null;
  if (process.env['PLATFORM'] === 'rn') {
    try {
      // const aStorage = require('react-native').AsyncStorage;
      // authKey = await aStorage.getItem('auth_key');
    } catch (e) {
      // console.log(e);
    }
  } else if (process.env['PLATFORM'] === 'reactjs') {
    authKey = cookies.get('auth_key');
  }
  return authKey;
}

// Получение токена авторизации в зависимости от типа полатформы
async function getLanguage() {
  const lang = cookies.get('locale');
  return lang || undefined;
}

// Генерируем url строку
async function getUrl(path, pathParams) {
  const baseUrl = process.env['API_URL'];
  let getParams = '';

  if (
    pathParams &&
    typeof pathParams === 'object' &&
    Object.keys(pathParams).length !== 0
  ) {
    getParams = `?${qs.stringify(pathParams)}`;
  }

  return baseUrl + path + getParams;
}

// Устанавливаем заголовки
async function getHeaders() {
  let headers = {
    'Content-Type': 'application/json'
  };

  const localeCode = getLocaleCode();
  if (localeCode) {
    headers = Object.assign(headers, {
      'Permanent-Language': localeCode
    });
  }

  // Добавляем токен авторизации если такой есть. await тк AsyncStorage асинхронный
  const AUTH_KEY = await getAutKey();
  if (AUTH_KEY) {
    headers = Object.assign(headers, {
      Authorization: `Bearer ${AUTH_KEY}`
    });
  }
  const LANG = await getLanguage();
  if (LANG) {
    headers = Object.assign(headers, {
      'accept-language': LANG
    });
  }

  return headers;
}

// Обертка для fetch
async function request(methodType, path, pathParams, data) {
  const method = methodType || 'GET';
  const url = await getUrl(path, pathParams);
  const headers = {
    ...(await getHeaders()),
    ...getClientSignatureHeader(methodType, url, data)
  };
  const credentials = 'include';

  let body;
  if (['POST', 'PUT'].indexOf(method) > -1) {
    if (data instanceof FormData) {
      delete headers['Content-Type'];
      body = data;
    } else if (Object.keys(data).length !== 0) {
      body = JSON.stringify(data);
    }
  }

  return fetch(url, { method, headers, body, credentials })
    .then(response => response)
    .catch(() => null);
}

export function get(path, pathParams = {}) {
  return request('GET', path, pathParams, {});
}

export function post(path, pathParams = {}, dataParams = {}) {
  return request('POST', path, pathParams, dataParams);
}

export async function uploadFiles(formData) {
  const environment = process.env;
  const baseUrl = environment.FILE_SERVICE_URL;
  if (!baseUrl || !baseUrl.trim()) {
    throw new Error('FILE_SERVICE_URL is not configured');
  }
  const authKey = await getAutKey();
  const headers = authKey ? { Authorization: `Bearer ${authKey}` } : {};
  return fetch(`${baseUrl.replace(/\/+$/, '')}/files`, {
    method: 'POST',
    headers,
    body: formData
  });
}

export function put(path, pathParams = {}, dataParams = {}) {
  return request('PUT', path, pathParams, dataParams);
}

export function del(path, pathParams = {}) {
  return request('DELETE', path, pathParams, {});
}



// WEBPACK FOOTER //
// ./src/mt-react-common/utils/apiClient/index.js